module.exports = __webpack_public_path__ + "media/sports.31f8e7fa.png";